import type { HighDemandBtnSaturation, Saturation } from './HighDemand.type';

export function validatePartnerSaturation(
  saturation: HighDemandBtnSaturation,
): Saturation {
  return saturation === 'hidden' ? 'deactivated' : saturation;
}
